import React, { useEffect, useState } from 'react'
import { AgxDatePicker, AgxRow } from '@urbanx/agx-ui-components'
import './DateRangeSelector.scss'
import dayjs from 'dayjs'

interface DateRangeSelectorProps {
  startDate: string | undefined
  endDate: string | undefined
  onChange: ({
    startDate,
    endDate,
  }: {
    startDate: string
    endDate: string
  }) => void
}

const getDefaultDate = (date: string | undefined): string => {
  if (!date) {
    return dayjs().format('YYYY-MM-DD')
  }

  return dayjs(date).format('YYYY-MM-DD')
}

const DateRangeSelector: React.FC<DateRangeSelectorProps> = ({
  startDate,
  endDate,
  onChange,
}) => {
  const [localStartDate, setLocalStartDate] = useState<string>(
    getDefaultDate(startDate)
  )
  const [localEndDate, setLocalEndDate] = useState<string>(
    getDefaultDate(endDate)
  )

  useEffect(() => {
    onChange({
      startDate: localStartDate,
      endDate: localEndDate,
    })
  }, [localStartDate, localEndDate])

  return (
    <AgxRow fill veryLargeGap>
      <AgxDatePicker
        id="networkDateStart"
        extraClasses="agxDatePickerConstrained"
        date
        noOptionalLabel
        stretch
        defaultValue={localStartDate}
        onValueChanged={(e) => {
          const dateObj = dayjs(e.value)
          if (dateObj.isValid()) {
            setLocalStartDate(dateObj.format('YYYY-MM-DD'))
          }
        }}
      />
      <AgxDatePicker
        id="networkDateEnd"
        extraClasses="agxDatePickerConstrained"
        date
        noOptionalLabel
        stretch
        defaultValue={localEndDate}
        onValueChanged={(e) => {
          const dateObj = dayjs(e.value)
          if (dateObj.isValid()) {
            setLocalEndDate(dateObj.format('YYYY-MM-DD'))
          }
        }}
      />
    </AgxRow>
  )
}

export default DateRangeSelector
